import { ProductModelType } from '@teinor/erp/types/company/product'
import { TitleSButtonPermissioned } from '../../../../../../../../../../baseComponents/Layout/TitleAndRightLayout'
import { TwinSimpleTable } from '../../../../../../../../../../baseComponents/TwinTable'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderString, ShowRow } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { CustomRenderStock } from '../../../../../../../../../Stock/customRenderStock'
import { StockParentExtendedTy } from '../../../../../../../../../Stock/types'
import useEditDeleteModal from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import ModalCheckProductStock from '../../../../../../../../../Stock/ModalCheckProductStock'


interface StockProductQuoteTabProps extends TableComponentBaseScreenInnerProps  {
    basicData: ProductModelType
}

const StockProductQuoteTab: React.FC<StockProductQuoteTabProps> = ({ basicData, setTableInstance }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal } = useEditDeleteModal()
    const columns: ColumnTableSchema<StockParentExtendedTy> = [
        {
            id: 'WarehouseId',
            dataKey: 'WarehouseId',
            label: t('warehouse', 'Almacén'),
            sortable: true,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.Warehouse?.name} />,
        },
        {
            id: 'stock',
            dataKey: 'stock',
            label: t('units', 'Unidades'),
            customRender: (parameterValue, allRowData) => <CustomRenderStock allRowData={allRowData} />,
        },
        {
            id: 'location',
            dataKey: 'location',
            label: t('location', 'Localización'),
        },
        {
            id: 'minimum',
            dataKey: 'minimum',
            label: t('minimum', 'Mínimo'),
        },
        {
            id: 'optimum',
            dataKey: 'optimum',
            label: t('optimum', 'Óptimo'),
        },
        {
            id: 'show',
            dataKey: 'WarehouseId',
            label: '',
            width: 50,
            simpleLabel: t('see', 'Ver'),
            customRender: (parameterValue, allRowData) => <ShowRow key={'show' + parameterValue} {...{ parameterValue, allRowData }} onClick={(e) => setOpenModal({
                type: 'edit',
                allRowData: allRowData
            })} />
        },
    ]
    return (
        <TitleSButtonPermissioned title={t('stock', 'Inventario')} buttonText={t('save', 'Guardar')} userPermissions={{ n: 1, permission: 'read' }} permission='update'>
            <TwinSimpleTable columns={columns} name='productStock' getDataFrom='/api/app/product/stock/getAllStockParentsComplete' defaultOrder={{ order: 'desc', defaultOrderField: 'ProductId' }} setTableInstance={setTableInstance} extraWhereParams={{ 'StockParent.ProductId': basicData?.id }} hideChangeColumnsButton={true} />
            {openModal?.type === 'edit' ? <ModalCheckProductStock allRowData={openModal.allRowData} setOpened={() => setOpenModal(null)} onSubmit={() => {}} /> : null }
        </TitleSButtonPermissioned>
    )
}

export default StockProductQuoteTab